import { render, staticRenderFns } from "./projectComposition.vue?vue&type=template&id=c072548e&"
import script from "./projectComposition.vue?vue&type=script&lang=js&"
export * from "./projectComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports